import React from "react";
import {NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import {useLocationFormState} from "../../components/treeMarking/TreeMarkingForm/TreeMarkingAddForm";
import TreeMarkingAddFormProvider from "../../components/treeMarking/TreeMarkingForm/TreeMarkingAddFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const TreeMarkingAddEditPage = () => {

    useTitle(t`Add Tree Marking`);

    return (
        <Box data-testid="TreeMarking-add-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="TreeMarking-add-title"
                    >
                        <Trans>Add Tree Marking</Trans>
                    </Typography>
                    <TreeMarkingAddFormProvider
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default TreeMarkingAddEditPage;
